module.exports = __webpack_public_path__ + "img/dashboardachover.0826b6a6.svg";